module.exports = new __parcel__URL__("spotlight-image.e0f0f839.svg").toString();